"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSignedMsgUserOrdersFilter = exports.getUserStatsIsReferredOrReferrerFilter = exports.getUserStatsIsReferredFilter = exports.getUserStatsFilter = exports.getUserWithName = exports.getUserThatHasBeenLP = exports.getUserWithAuctionFilter = exports.getUserWithoutOrderFilter = exports.getUserWithOrderFilter = exports.getNonIdleUserFilter = exports.getUserFilter = void 0;
const bs58_1 = __importDefault(require("bs58"));
const anchor_1 = require("@coral-xyz/anchor");
const userName_1 = require("./userName");
function getUserFilter() {
    return {
        memcmp: {
            offset: 0,
            bytes: bs58_1.default.encode(anchor_1.BorshAccountsCoder.accountDiscriminator('User')),
        },
    };
}
exports.getUserFilter = getUserFilter;
function getNonIdleUserFilter() {
    return {
        memcmp: {
            offset: 4350,
            bytes: bs58_1.default.encode(Uint8Array.from([0])),
        },
    };
}
exports.getNonIdleUserFilter = getNonIdleUserFilter;
function getUserWithOrderFilter() {
    return {
        memcmp: {
            offset: 4352,
            bytes: bs58_1.default.encode(Uint8Array.from([1])),
        },
    };
}
exports.getUserWithOrderFilter = getUserWithOrderFilter;
function getUserWithoutOrderFilter() {
    return {
        memcmp: {
            offset: 4352,
            bytes: bs58_1.default.encode(Uint8Array.from([0])),
        },
    };
}
exports.getUserWithoutOrderFilter = getUserWithoutOrderFilter;
function getUserWithAuctionFilter() {
    return {
        memcmp: {
            offset: 4354,
            bytes: bs58_1.default.encode(Uint8Array.from([1])),
        },
    };
}
exports.getUserWithAuctionFilter = getUserWithAuctionFilter;
function getUserThatHasBeenLP() {
    return {
        memcmp: {
            offset: 4267,
            bytes: bs58_1.default.encode(Uint8Array.from([99])),
        },
    };
}
exports.getUserThatHasBeenLP = getUserThatHasBeenLP;
function getUserWithName(name) {
    return {
        memcmp: {
            offset: 72,
            bytes: bs58_1.default.encode(Uint8Array.from((0, userName_1.encodeName)(name))),
        },
    };
}
exports.getUserWithName = getUserWithName;
function getUserStatsFilter() {
    return {
        memcmp: {
            offset: 0,
            bytes: bs58_1.default.encode(anchor_1.BorshAccountsCoder.accountDiscriminator('UserStats')),
        },
    };
}
exports.getUserStatsFilter = getUserStatsFilter;
function getUserStatsIsReferredFilter() {
    return {
        memcmp: {
            offset: 188,
            bytes: bs58_1.default.encode(Buffer.from(Uint8Array.from([2]))),
        },
    };
}
exports.getUserStatsIsReferredFilter = getUserStatsIsReferredFilter;
function getUserStatsIsReferredOrReferrerFilter() {
    return {
        memcmp: {
            offset: 188,
            bytes: bs58_1.default.encode(Buffer.from(Uint8Array.from([3]))),
        },
    };
}
exports.getUserStatsIsReferredOrReferrerFilter = getUserStatsIsReferredOrReferrerFilter;
function getSignedMsgUserOrdersFilter() {
    return {
        memcmp: {
            offset: 0,
            bytes: bs58_1.default.encode(anchor_1.BorshAccountsCoder.accountDiscriminator('SignedMsgUserOrders')),
        },
    };
}
exports.getSignedMsgUserOrdersFilter = getSignedMsgUserOrdersFilter;
